import { Worksheet } from "exceljs";

import type { PlanColumnSpans } from "./types";

export function mergePlanSpanCells(
  worksheet: Worksheet,
  rowNumber: number,
  planIdsInOrder: string[],
  planColumnSpans?: PlanColumnSpans,
): void {
  let currentColumn = 2;

  planIdsInOrder.forEach((planId) => {
    const span = planColumnSpans?.[planId] ?? 1;

    if (span > 1) {
      worksheet.mergeCells(
        rowNumber,
        currentColumn,
        rowNumber,
        currentColumn + span - 1,
      );
    }

    currentColumn += span;
  });
}

/**
 * Merge cells across each plan group's full column span for a single row.
 *
 * Used for plan-group-level total rows, where the total value sits on the
 * group's first plan and should read as one value across all of the group's
 * plan columns.
 */
export function mergeGroupSpanCells(
  worksheet: Worksheet,
  rowNumber: number,
  planIdsInOrder: string[],
  planGroupIdByPlanId: Record<string, string>,
  planColumnSpans?: PlanColumnSpans,
): void {
  let currentColumn = 2;
  let groupStartColumn = 2;
  let currentGroupId: string | undefined;

  const closeGroup = (endColumnExclusive: number): void => {
    if (
      currentGroupId !== undefined &&
      endColumnExclusive - groupStartColumn > 1
    ) {
      worksheet.mergeCells(
        rowNumber,
        groupStartColumn,
        rowNumber,
        endColumnExclusive - 1,
      );
    }
  };

  planIdsInOrder.forEach((planId) => {
    const groupId = planGroupIdByPlanId[planId];

    if (currentGroupId === undefined) {
      currentGroupId = groupId;
      groupStartColumn = currentColumn;
    } else if (groupId !== currentGroupId) {
      closeGroup(currentColumn);
      currentGroupId = groupId;
      groupStartColumn = currentColumn;
    }

    currentColumn += planColumnSpans?.[planId] ?? 1;
  });

  closeGroup(currentColumn);
}
